import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box, Group, Image, Text, Anchor } from '@mantine/core';
import { IDLE_MS } from '../../utils/cvdl';
import { useIdleReset } from '../../hooks/useIdleReset';
import { useKiosk } from '../../context/KioskContext/KioskContext';
import forvetLogo from '../../assets/logo-forvet-dark.svg';   // version para fondo claro
import ipgLogo from '../../assets/grand/ipg-logo.png';
import './kiosk.css';
import './cvdlClaro.css';

export function KioskLayout() {
  const { reset, isSpinning, rutas } = useKiosk();
  const { pathname } = useLocation();
  const enAtractor = pathname === rutas.base;

  useIdleReset(reset, IDLE_MS, !enAtractor && !isSpinning);

  // Fullscreen: requiere gesto del usuario, por eso va colgado del primer click
  useEffect(() => {
    const enter = () => document.documentElement.requestFullscreen?.().catch(() => { });
    document.addEventListener('click', enter, { once: true });
    return () => document.removeEventListener('click', enter);
  }, []);

  return (
    <Box
      className="kiosk cvdl-claro"
      style={{
        height: '100dvh', display: 'flex', flexDirection: 'column',
        overflow: 'hidden', userSelect: 'none', WebkitTapHighlightColor: 'transparent',
        background: 'linear-gradient(180deg, #FFFFFF 0%, #F4FAFD 100%)',
      }}
    >
      <Group justify="space-between" maw='768px' m='0 auto' align="center" px="xl" py="md">
        <Image src={forvetLogo} alt="FORVET" h={46} w="auto" fit="contain" />
        <Image src={ipgLogo} alt="IPG Iribarren" h={120} w="auto" fit="contain" />

        {/* <Group gap="sm" align="center"> */}
        {/* <Text size="sm" c="var(--color-text-primary)" fw={600}>Junto a</Text> */}
        {/* <Image src={ipgLogo} alt="IPG Iribarren" h={120} w="auto" fit="contain" /> */}
        {/* </Group> */}
      </Group>

      <Box style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </Box>

      <Group justify="center" px="xl" py="sm">
        <Anchor href="https://forvet.org/cvdl/bases" size="sm" c="forvet.6">
          Bases y condiciones · forvet.org/cvdl/bases
        </Anchor>
      </Group>
    </Box>
  );
}
